module.exports = __webpack_public_path__ + "img/guocm.b46a49d3.png";